"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function findPlanElement(plan, row) {
    var groupIndex = -1;
    var placementIndex = -1;
    var generateKey = (function (inPlacements) {
        return inPlacements.map(function (placement) { return placement.tag; }).join(";");
    });
    if (row) {
        if (row["_group"]) {
            var rowTags_1 = generateKey(row["_group"]["mediumGroup"]);
            plan.mediumGroups.forEach(function (mediumGroup, index) {
                var planTags = generateKey(mediumGroup.mediumGroup);
                if (planTags === rowTags_1) {
                    groupIndex = index;
                }
            });
        }
        else if (row["_placement"]) {
            var rowPlacement_1 = _.get(row, "_placement");
            plan.mediumGroups.forEach(function (mediumGroup, gIndex) {
                mediumGroup.mediumGroup.forEach(function (placement, pIndex) {
                    if (_.get(rowPlacement_1, "tag") === placement.tag) {
                        groupIndex = gIndex;
                        placementIndex = pIndex;
                    }
                });
            });
        }
    }
    return { groupIndex: groupIndex, placementIndex: placementIndex };
}
exports.findPlanElement = findPlanElement;
//# sourceMappingURL=findPlanElement.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/datalayerHelpers/findPlanElement.js
// module id = 48
// module chunks = 0